<template>
  <pt-banner-detail class="pt-banner-detail__withData" :position="position"  :id="id" :bannerList="bannerList" @submit="submit" :positionLoading="positionLoading" :loading="loading" :positionDetail="positionDetail"></pt-banner-detail>
</template>

<script>
import PtBannerDetail from './index'
export default {
  name: 'pt-banner-detail__withData',
  components: {
    'pt-banner-detail': PtBannerDetail
  },
  props: {
    position: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bannerList: [],
      loading: false,
      positionDetail: {},
      positionLoading: false
    }
  },
  methods: {
    promotionBannersPosition () {
      let data = {
        type: 'CAROUSEL',
        id: this.position
      }
      this.positionLoading = true
      this.$store.dispatch('promotionBannersPosition', data).then(res => {
        this.positionLoading = false
        this.positionDetail = res
      }).catch(err => {
        this.positionLoading = false
        this.$message.error(err || '查询广告位位置详情失败')
      })
    },
    getBnnerDetail () {
      let data = {
        example: {
          position: this.position,
          type: 'CAROUSEL'
        },
        pageable: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('bannerByExample', data).then(res => {
        this.bannerList = res
      }).catch(err => {
        this.$message.error(err || '获取广告位列表失败')
      })
    },
    submit (val) {
      val.type = 'CAROUSEL'
      val.position = this.position
      this.bannersReplace(val)
    },
    bannersReplace (val) {
      this.loading = true
      this.$store.dispatch('bannersReplace', val).then(res => {
        this.loading = false
        this.$message.success('保存广告位成功')
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '保存广告位失败')
      })
    }
  },
  created () {
    this.promotionBannersPosition()
    this.getBnnerDetail()
  }
}
</script>
